import type { PartnerData } from '@optionway/models';
import { modelsImpl } from '@optionway/models';

interface PartnerDataStore {
  partnerData: PartnerData;
}

export const usePartnerDataStore = defineStore('partner-data', {
  state: (): PartnerDataStore => ({
    partnerData: new modelsImpl.PartnerDataImpl(),
  }),
  getters: {
    subscribedToNewsletter: (state): boolean => !!state.partnerData.newsletter,
    consentsToNewsletterTracking: (state): boolean => !!state.partnerData.newsletterTrackingConsent,
  },
  actions: {
    setNewsletter(checked: boolean) {
      this.partnerData.newsletter = checked;
      if (!checked) {
        this.partnerData.newsletterTrackingConsent = false;
      }
    },
    setNewsletterTrackingConsent(checked: boolean) {
      this.partnerData.newsletterTrackingConsent = checked;
    },
  },
});
